





















































import { Component, Vue, Model, Watch } from "vue-property-decorator";
import IInput from "@/components/i-input.vue";
@Component({
  components: {
    IInput
  }
})
export default class IMomentEditor extends Vue {
  @Model("model") value!: any;
  @Watch("value")
  watchValue(val: any) {
    this.onValueChange(val);
  }

  private onValueChange(value: any) {
    this.$emit("model", value);
    this.$emit("on-change", value);
  }
}
